import { useQuery } from '@tanstack/react-query';
import type { RecommendationRequestWrapper } from 'autogen/swagger/all';
import {
    GetByBasket,
    GetByHomePage,
    GetByPowerstep,
    GetByPowerstepTwo,
    GetByProductGroupId,
    GetByProductId,
    GetBySearchResult,
    GetByZeroSearchResult,
    GetCustom,
    GetForReceiptPage,
    GetFromPlacement,
    RecommendationRequestDiscriminator
} from 'autogen/swagger/all';

export default function useRecommendationModelAsync(
    recommendationRequestParams: RecommendationRequestWrapper['recommendationRequest']
) {
    // We find out which type of recommendation request we should be fetching.
    const fetcher = RecommendationRequestDiscriminator(
        recommendationRequestParams,
        (productModel) => () => GetByProductId(productModel),
        () => GetByBasket,
        (productGroupModel) => () => GetByProductGroupId(productGroupModel),
        (SearchResultModel) => () => GetBySearchResult(SearchResultModel),
        (zeroSearchResultModel) => () => GetByZeroSearchResult(zeroSearchResultModel),
        (homePageModel) => () => GetByHomePage(homePageModel),
        (powerstepModel) => () => GetByPowerstep({ ...powerstepModel, forBrandClub: false }),
        () => () => GetByPowerstepTwo(),
        (receiptPageModel) => () => GetForReceiptPage(receiptPageModel),
        (customModel) => () => GetCustom(customModel),
        (placementModel) => () => GetFromPlacement(placementModel),
        () => {
            throw new Error('Unknown recommendation type');
        }
    );

    return useQuery([recommendationRequestParams], fetcher, {
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
            if (data.jsDebug) {
                globalThis.RR_DEBUG = JSON.parse(data.jsDebug);
            }
        }
    });
}
